import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { reducer as reduxFormReducer } from 'redux-form';

import account from './services/account';
import adblocker from './services/adblocker';
import authentication from './services/authentication';
import banner from './services/banner';
import category from './services/category';
import contactrequest from './services/contactrequest';
import coupon from './services/coupon';
import criteria from './services/criteria';
import discount from './services/discount';
import directory from './services/directory';
import ebon from './services/ebon';
import monetico from './services/monetico';
import faq from './services/faq';
import filter from './services/filter';
import flashingTicket from './services/flashing-ticket';
import header from './services/header';
import i18n from './services/i18n';
import interstitiel from './services/interstitiel';
import mea from './services/mea';
import modal from './services/modal';
import nav from './services/nav';
import partner from './services/partner';
import search from './services/search';
import shop from './services/shop';
import toolbar from './services/toolbar';
import unsubscribe from './services/unsubscribe';

const rootReducer = combineReducers({
    [account.constants.NAME]: account.reducer,
    [adblocker.constants.NAME]: adblocker.reducer,
    [authentication.constants.NAME]: authentication.reducer,
    [banner.constants.NAME]: banner.reducer,
    [category.constants.NAME]: category.reducer,
    [contactrequest.constants.NAME]: contactrequest.reducer,
    [coupon.constants.NAME]: coupon.reducer,
    [criteria.constants.NAME]: criteria.reducer,
    [discount.constants.NAME]: discount.reducer,
    [directory.constants.NAME]: directory.reducer,
    [ebon.constants.NAME]: ebon.reducer,
		[monetico.constants.NAME]: monetico.reducer,
    [faq.constants.NAME]: faq.reducer,
    [filter.constants.NAME]: filter.reducer,
    [flashingTicket.constants.NAME]: flashingTicket.reducer,
    form: reduxFormReducer,
    [header.constants.NAME]: header.reducer,
    [i18n.constants.NAME]: i18n.reducer,
    [interstitiel.constants.NAME]: interstitiel.reducer,
    [mea.constants.NAME]: mea.reducer,
    [modal.constants.NAME]: modal.reducer,
    [nav.constants.NAME]: nav.reducer,
    [partner.constants.NAME]: partner.reducer,
    routing: routerReducer,
    [search.constants.NAME]: search.reducer,
    [shop.constants.NAME]: shop.reducer,
    [toolbar.constants.NAME]: toolbar.reducer,
    [unsubscribe.constants.NAME]: unsubscribe.reducer
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/rootReducer.js